import AppDispatcher from '../AppDispatcher';

const TagsStore = {

  _items: {},

  getAll: function (context) {
    return this._items[context];
  },

  getForSelect: function (context) {
    let options = [];

    for (let i = 0; i < this._items[context].length; i++) {
      options.push({
        value: this._items[context][i],
        label: this._items[context][i]
      });
    }
    return options;
  },

  emitChange: function (context) {
    this.trigger(context);
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (context, callback) {
    this.bind(context, callback);
  },

  removeChangeListener: function (context, callback) {
    this.unbind(context, callback);
  },

  handleDispatcher: function (action) {
    switch (action.actionType) {
      case Constants.ActionTypes.TAGS.UPDATE:
        this._items[action.context] = action.items;
        this.emitChange(action.context);
        break;
    }
  }
};

MicroEvent.mixin(TagsStore);

AppDispatcher.register(TagsStore.handleDispatcher.bind(TagsStore));

export default TagsStore;



// WEBPACK FOOTER //
// ./src/js/Stores/TagsStore.js